import axios from 'axios'
import Toastr from 'toastr'
import router from './router'
import Config from './config/config'
import store from './store/'

const errorResponseHandler = async (error) => {
    // check for errorHandle config
    if (
        error && error.config && error.config.hasOwnProperty('errorHandle') &&
    error.config.errorHandle === false
    ) {
        return Promise.reject(error)
    }
    if (error.response && error.response.data === 'Unauthorized') {
        await store.dispatch('unsetUser')
        router.push('/signin')
    }
    // if has response show the error
    if (error.response) {
        if (
            error.response &&
      error.response.data &&
      error.response.data.displayMsg
        ) {
            Toastr.error(
                error.response.data.displayMsg.e.msg,
                error.response.data.displayMsg.e.head
            )
        } else {
            console.log(error.status, error.message, error.response)
        }
    } else if (error.message) {
        if (error.message === 'Network Error') { Toastr.error('Please contact support team or try again', error.message) } else Toastr.error(String(error), 'Unhandled Exception')
    }
}

let axiosWebApi = axios.create({
    baseURL: Config.WAPI_URL,
    headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.token
    }
})

// apply interceptor on request
axiosWebApi.interceptors.request.use((request) => {
    const isAuthenticated = !(store.getters.currentUser && !localStorage.token)
    if (!isAuthenticated) {
        router.push('/signin')
    } else {
        request.headers.Authorization = 'Bearer ' + localStorage.token
        return request
    }
})

// apply interceptor on response
axiosWebApi.interceptors.response.use((response) => {
    return response
}, errorResponseHandler)

// Vue.use(VueAxios, axiosWebApi)

export default axiosWebApi
